module.exports = __webpack_public_path__ + "media/images/credits_logo-ba0be7b12912e027bba043a6eb4fb744176be8dab06978c154f785cdc773a468.png";